import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./AppRoute";
import withRBAC from "./components/RbacManagement/RBAC";
import IdleTimeCounter from "./config/IdleTimeCounter";
import "./App.scss";
import useLogoutOnTabClose from "./customHooks/useLogoutOnTabClose";

const App = () => {
  useLogoutOnTabClose();
  return (
    <BrowserRouter>
      <IdleTimeCounter />
      <AppRoute />
    </BrowserRouter>
  );
};

export default withRBAC(App);
